import Cookies from 'universal-cookie';
import { CZEN_VISITOR_COOKIE_KEY } from '../constants';

export function getCzenVisitorId() {
  const cookies = new Cookies();
  return cookies.get(CZEN_VISITOR_COOKIE_KEY);
}
